import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { statenIslandConfig } from "./data";

export default function StatenIslandPage() {
  return <CityPageTemplate config={statenIslandConfig} />;
}